// Library Methods
import { useMutation, useQueryClient } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// API
import { generateProgressionReportFile } from "../../api";

export const useGenerateProgressionFile = (clinicId: string | undefined) => {
  const queryClient = useQueryClient();
  const { getToken } = useTokenAccess();

  return useMutation({
    mutationFn: async (params: {
      patientId: string;
      analysisId: string;
      fileType: string;
    }) => {
      if (!clinicId) throw new Error();

      try {
        const token = await getToken();
        const controller = new AbortController();
        return generateProgressionReportFile(
          token,
          clinicId,
          params.patientId,
          params.analysisId,
          params.fileType,
          controller.signal
        );
      } catch (error) {
        throw error;
      }
    },
    // Invalidate query cache
    onSuccess: (_) => {
      queryClient.invalidateQueries({
        queryKey: ["progression-report-file"],
      });
    },
  });
};
